import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'

const usePutMyBranch = (branchNameRef) => {
	const navigate = useNavigate()

	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const request = () => {
		fetchRequest('PUT', `/competition-manager/profile`, {
			branch_name: branchNameRef?.current?.value?.trim(),
		})
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				navigate('/sub-manager/manage')
				break
			case 400:
				if (fetchResult?.data?.error_code === 'branch_name')
					setAlert('브랜드 이름을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
		}
	}, [fetchResult])

	return [request]
}

export default usePutMyBranch
